module.exports = __webpack_public_path__ + "static/media/mindy_clipboard_physician 5.2b4e0252.png";